import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditWarningPopoverShown.meta';

export type UseTrackCreditWarningPopoverShownParams = CreditAnalyticsParams & {
  type: 'popover' | 'banner';
};

export const useTrackCreditWarningPopoverShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditWarningPopoverShown = useCallback(
    (params: UseTrackCreditWarningPopoverShownParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditWarningPopoverShown };
};
